import React, { useEffect, useState } from 'react';
import './Empresas.css';

import { Button, Box, IconButton, FormControl, InputLabel, Select, MenuItem, Paper, Typography, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Loading from '../../components/loading/Loading';
import { UserInfo } from '../../dto/UserInfo';
import { mostraMensagemErro } from '../../helpers/Notificacoes';
import SearchIcon from '@mui/icons-material/Search';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import Paginacao from '../../components/paginacao/paginacao';
import { formataFiltrosBusca } from '../../helpers/ValidaAgente';
import MyTextField, { MaskType } from '../../components/inputs/inputBusca';
import { EmpresaServices } from '../../services/EmpresaService';
import { Empresa } from '../../dto/Empresa';
import CustomTableSelectEmpresas from '../../components/customTableSelectEmpresas/customTableSelectEmpresas';
import { BusinessRounded } from '@mui/icons-material';

export function EmpresaModule() {
    const navigate = useNavigate();
    const userInfo: UserInfo = JSON.parse(localStorage.getItem('udbs')!);

    const [empresas, setEmpresas] = useState([]);
    const [buscouEmpresas, setBuscouEmpresas] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(15);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const arrayColunas: string[] = ['codEmpresa', 'nomeEmpresa', 'apiKey', 'nroUsuarios'];
    const [colunaFilter, setColunaFilter] = useState<string | null>(null);
    const [colunas, setColunas] = useState<string[]>(arrayColunas);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredEmpresas, setFilteredEmpresas] = useState([]);
    const [erro, setErro] = useState('');

    const empresaService = new EmpresaServices();

    useEffect(() => {
        if (erro !== "") {
            mostraMensagemErro(erro);
        }
    }, [erro]);

    useEffect(() => {
        if (searchTerm.trim() === '' || !buscouEmpresas) {
            buscaEmpresas();
        }
    }, [searchTerm]);


    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredEmpresas(empresas);
            setTotalRegistros(empresas.length)
        }
    }, [searchTerm, empresas]);


    async function buscaEmpresas() {
        setIsLoading(true);

        const response = await empresaService.get(`/v1/empresas`);
        if (response.codigo !== 200) {
            if (response.codigo === 404) {
                setBuscouEmpresas(true);
                setErro('Não há registros');
            } else {
                setErro(response.mensagem);
            }

            setIsLoading(false);
        } else {
            setErro('');
            setEmpresas(response.status ?? []);
            setFilteredEmpresas(response.status ?? []);
            setTotalRegistros(response.status.total);
            setIsLoading(false);
            setBuscouEmpresas(true);
        }
    }


    const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    const handleBuscarComFiltro = async () => {
        await buscaEmpresasFiltro()
        setPage(1);
    };

    async function buscaEmpresasFiltro() {

        const response = await empresaService.get(`/v1/empresas?${colunaFilter}=${searchTerm}`);
        if (response.codigo !== 200) {
            if (response.codigo === 404) {
                setBuscouEmpresas(true);
                setErro('Não há registros');
            } else {
                setErro(response.mensagem);
            }

            setIsLoading(false);
        } else {
            setErro('');
            setEmpresas(response.status ?? []);
            setFilteredEmpresas(response.status ?? []);
            setTotalRegistros(response.status.total);
            setIsLoading(false);
            setBuscouEmpresas(true);
        }
    }

    const dadosPaginados = filteredEmpresas.slice(
        (page - 1) * pageSize,
        page * pageSize
    );

    const novaEmpresa = () => {
        navigate("/mvp", {
            state: {
                propsPage: "cadEmpresa"
            }
        })
    }

    async function editarEmpresa(empresa: Empresa) {
        navigate("/mvp", {
            state: {
                empresa,
                propsPage: "editarEmpresa"
            }
        })
    }

    async function handleEditarEmpresa(empresa: Empresa) {
        await editarEmpresa(empresa);
    }

    async function handleVisualizarEmpresa(empresa: Empresa) {
        await navigate("/mvp", {
            state: {
                empresa,
                propsPage: "visualizarEmpresa"
            }
        })
    }

    return (
        <div className="Home">
            {isLoading && <Loading />}
            <Paper elevation={0} className='empresas-paper-header'>
                <Box className='empresas-header-top'>
                    <Box className='empresas-title-wrap'>
                        <Box className='empresas-title-icon'>
                            <BusinessRounded />
                        </Box>
                        <Box>
                            <Box className='empresas-title-line'>
                                <Typography variant='h6' className='empresas-title'>
                                    Empresas Cadastradas
                                </Typography>
                            </Box>
                            <Typography className='empresas-subtitle'>
                                Acompanhe as empresas cadastradas e suas informações detalhadas.
                            </Typography>
                        </Box>
                    </Box>
                    <Divider className='empresas-divider' />
                </Box>
                <Button
                    className='empresas-btn-novo'
                    variant='contained'
                    onClick={novaEmpresa}
                >
                    Nova empresa
                </Button>
                <Box className='empresas-filtros-row'>
                    <FormControl size='small' className='empresas-form-control'>
                        <InputLabel shrink>Filtrar por</InputLabel>
                        <Select
                            value={colunaFilter}
                            onChange={(e: any) => {
                                setColunaFilter(e.target.value);
                                setSearchTerm("");
                            }}
                            label='Filtrar por'
                            displayEmpty
                        >
                            {colunas.map((item) => (
                                <MenuItem key={item} value={item} sx={{ fontSize: '14px' }}>
                                    {item === 'codEmpresa' ? 'Código Empresa' :
                                        item === 'nomeEmpresa' ? 'Descrição' :
                                            item === 'apiKey' ? 'ApiKey' :
                                                item === 'nroUsuarios' ? 'Usuários' :
                                                    item.charAt(0).toUpperCase() + item.slice(1)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <Box className="empresas-search-box">
                        <MyTextField
                            tipo={colunaFilter as MaskType}
                            value={searchTerm}
                            onValueChange={setSearchTerm}
                            onClear={() => {
                                setSearchTerm("");
                                setFilteredEmpresas(empresas);
                                setColunaFilter(null);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleBuscarComFiltro();
                                }
                            }}
                        >
                        </MyTextField>
                    </Box>

                    <IconButton
                        aria-label="Pesquisar"
                        className='empresas-btn-buscar'
                        onClick={handleBuscarComFiltro}
                        disabled={searchTerm === "" && colunaFilter !== "dataLancamento"}
                    >
                        {searchTerm !== "" || colunaFilter === "dataLancamento" ? <SearchIcon /> : <SearchOffIcon />}
                    </IconButton>

                    <button
                        className='empresas-limpar'
                        onClick={() => {
                            setSearchTerm("");
                            setFilteredEmpresas(empresas);
                            setColunaFilter(null);
                        }}
                    >
                        Limpar filtros
                    </button>
                </Box>
            </Paper>
            {/*  <Box className="PanelFiltros">

                <Button
                    className='btnNovoPedido'
                    variant="contained"
                    onClick={novaEmpresa}
                    sx={{ maxWidth: 150, backgroundColor: '#5693B9', color: 'white', fontWeight: 'bold' }}>
                    Nova empresa
                </Button>

                <FormControl
                    sx={{
                        minWidth: 200,
                        '& .MuiOutlinedInput-root': {
                            backgroundColor: '#fff'
                        }
                    }}
                >
                    <InputLabel size="small" sx={{ fontSize: '14px' }}>Filtrar por</InputLabel>
                    <Select
                        value={colunaFilter}
                        onChange={(e: any) => {
                            setColunaFilter(e.target.value)
                            setSearchTerm("");
                        }}
                        sx={{ fontSize: '14px' }}
                        size='small'
                        label="Filtrar por"
                    >
                        {colunas.map((item) => (
                            <MenuItem key={item} value={item} sx={{ fontSize: '14px' }}>
                                {item === 'codEmpresa' ? 'Código Empresa' :
                                    item === 'nomeEmpresa' ? 'Descrição' :
                                        item === 'apiKey' ? 'ApiKey' :
                                            item === 'nroUsuarios' ? 'Usuários' :
                                                item.charAt(0).toUpperCase() + item.slice(1)}
                            </MenuItem>
                        ))}

                    </Select>
                </FormControl>
                <Box className="SearchContainer">
                    <MyTextField
                        tipo={colunaFilter as MaskType}
                        value={searchTerm}
                        onValueChange={setSearchTerm}
                        onClear={() => {
                            setSearchTerm("");
                            setFilteredEmpresas(empresas);
                            setColunaFilter(null);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleBuscarComFiltro();
                            }
                        }}
                    >
                    </MyTextField>
                </Box>
                <IconButton
                    aria-label="Pesquisar"
                    sx={{
                        color: '#5693B9',
                        width: '20px',
                        height: '20px'
                    }}
                    onClick={handleBuscarComFiltro}
                    disabled={searchTerm === ""}
                >
                    {searchTerm !== "" ? <SearchIcon /> : <SearchOffIcon />}
                </IconButton>

            </Box>
 */}
            <div className='ContainerListaEmpresas'>
                <CustomTableSelectEmpresas
                    data={dadosPaginados}
                    buscouEmpresas={buscouEmpresas}
                    handleSetEmpresa={novaEmpresa}
                    handleEditarEmpresa={handleEditarEmpresa}
                    handleVisualizarEmpresa={handleVisualizarEmpresa}
                    editavel={true}
                />

                <div className="PaginationContainer">
                    <Paginacao
                        totalRegistros={totalRegistros}
                        paginaAtual={page}
                        porPagina={pageSize}
                        aoMudarPagina={handlePageChange}
                    />
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default EmpresaModule;
